/**
 * appstle-variant-sync.js
 *
 * Keeps input[name="id"] in sync with the selected Appstle Volume Discount
 * tier card, so the correct Shopify variant (1-bottle / 3-bottle / 6-bottle)
 * is always passed to the cart, cart drawer, and checkout.
 *
 * Also patches /cart/add fetch calls to:
 *   - Force quantity = 1  (the variant now represents the full pack)
 *   - Strip Appstle volume-discount bundle properties
 *     (pricing is baked into the variant price; the bundle backend
 *      must not re-discount on top of it)
 *
 * Subscription selling plans are handled by Appstle's own radio inputs,
 * which already live inside the product form and flow through automatically.
 */
(function () {
  'use strict';

  /** Build { tierIndex: variantId } from Shopify product meta, sorted by price asc. */
  function buildVariantMap() {
    var variants =
      (window.meta && window.meta.product && window.meta.product.variants) || [];
    if (!variants.length) return null;
    var sorted = variants.slice().sort(function (a, b) { return a.price - b.price; });
    var map = {};
    sorted.forEach(function (v, i) { map[i] = v.id; });
    return map;
  }

  /** Write variantId into the product form hidden input and fire a change event. */
  function setVariantId(variantId) {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!input) return;
    if (String(input.value) === String(variantId)) return;
    input.value = String(variantId);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /** Return the tier index from Appstle's selected-discount CSS class, or null. */
  function getSelectedTierIndex() {
    var el = document.querySelector('[class*="selected-discount-"][class*="-v2"]');
    if (!el) return null;
    var cls = null;
    for (var i = 0; i < el.classList.length; i++) {
      if (/selected-discount-\d+-v2/.test(el.classList[i])) {
        cls = el.classList[i];
        break;
      }
    }
    if (!cls) return null;
    var m = cls.match(/selected-discount-(\d+)-v2/);
    return m ? parseInt(m[1], 10) : null;
  }

  function installFetchPatch() {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url = '';
      try {
        url = typeof args[0] === 'string'
          ? args[0]
          : args[0] instanceof Request ? args[0].url : '';
      } catch (e) {}

      if (url.indexOf('/cart/add') !== -1) {
        var opts = args[1] || {};
        var body = opts.body;
        var params = null;
        var bodyType = null;

        if (body instanceof FormData) {
          params = body; bodyType = 'FormData';
        } else if (body instanceof URLSearchParams) {
          params = body; bodyType = 'URLSearchParams';
        } else if (typeof body === 'string') {
          try { params = new URLSearchParams(body); bodyType = 'string'; } catch (e) {}
        }

        if (params && typeof params.get === 'function') {
          var bundleType = params.get('properties[_appstle_bundles_type]');
          if (bundleType === 'VOLUME_DISCOUNT') {
            params.set('quantity', '1');
            var toRemove = [];
            params.forEach(function (v, k) {
              if (
                k.indexOf('properties[_appstle') === 0 ||
                k.indexOf('properties[__appstle') === 0
              ) { toRemove.push(k); }
            });
            toRemove.forEach(function (k) { params.delete(k); });
            var idInput = document.querySelector(
              'form[action*="/cart/add"] input[name="id"]'
            );
            if (idInput && idInput.value) params.set('id', idInput.value);
            args[1] = Object.assign({}, opts, {
              body: bodyType === 'string' ? params.toString() : params
            });
          }
        }
      }
      return origFetch.apply(this, args);
    };
  }

  var fetchPatched = false;

  function init() {
    var container = document.querySelector('.ab-volume-discount-rule-content-v2');
    if (!container) { setTimeout(init, 400); return; }

    var variantMap = buildVariantMap();
    if (!variantMap) return;

    var initIdx = getSelectedTierIndex();
    if (initIdx !== null && variantMap[initIdx] !== undefined) {
      setVariantId(variantMap[initIdx]);
    }

    var tierCards = container.querySelectorAll(':scope > div');
    tierCards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        setTimeout(function () {
          if (variantMap[index] !== undefined) setVariantId(variantMap[index]);
        }, 30);
      });
    });

    var observer = new MutationObserver(function () {
      var idx = getSelectedTierIndex();
      if (idx !== null && variantMap[idx] !== undefined) setVariantId(variantMap[idx]);
    });
    var root = document.getElementById('volumeDiscountContainer') || container;
    observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });

    if (!fetchPatched) { installFetchPatch(); fetchPatched = true; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
